import * as React from 'react';
import './App.scss';
import ModelStore from './stores/ModelStore';
import NavigationComponent from './components/NavigationComponent';
import { Provider, observer } from 'mobx-react';
import ThreeViewComponent from './components/ThreeViewComponent';
import ProductInfoComponent from './components/ProductInfoComponent';
import SubNavigationComponent from './components/SubNavigationComponent';
import IntroComponent from './components/IntroComponent';
import ContactComponent from './components/ContactComponent';
import ServiceListComponent from './components/ServiceListComponent';
import InfoBox from './components/InfoBox';
import Refinements from './components/Refinements';


const modelStore =  new ModelStore();

(window as any).modelStore = modelStore;

const craftForm = document.querySelector("form");

if(craftForm!==null){
  craftForm.parentElement!.removeChild(craftForm);
}

@observer
class App extends React.Component {

  public render() {


    if(modelStore.isLoading){
      return ( <div className="app">
                <div className="loader-wrap">
                  <div className="loader"/>
              </div>
              </div>);
    }

    return (
      <Provider modelStore = {modelStore} craftForm ={ craftForm }>
      <div className="app row">
          <div className="col-xs-12 col-md-12 col-lg-2" />
          <div className="col-xs-12 col-ms-12 col-lg-10">
          <div className="app-header">
            <NavigationComponent />
          </div>
          <div className="configurator row">
              {this.renderWorkspace()}
              {this.renderContactForm()}
              {this.renderProductInfo()}
              
          </div>
          </div> 
      </div>
      </Provider>
    );
  }

  private renderWorkspace():React.ReactNode{
      switch(modelStore.selectedIndex){
        case 0:
            return <IntroComponent /> 
        default:
             let className="col-xs-12 col-md-9 col-lg-9 workspace";
             if(modelStore.selectedIndex === 6){
                className="col-xs-12 col-md-6 col-lg-6 workspace"
             }
             return <div className={className} >
                        {this.renderSubnavigation()}
                        <ThreeViewComponent/>
                        {this.renderServiceBox()}
                    </div>

         
      }
  }
  private renderSubnavigation():React.ReactNode[] | null{
    switch(modelStore.selectedIndex){
      default:
           return [<SubNavigationComponent key="subnavigation"/>,<div className="h-dashed-line" key="dashed-line"/>]
      case 4:
      case 5:
      case 6:
      break;
    }
    return null;
  }
 
  private renderServiceBox():React.ReactNode | null {
    if(modelStore.selectedIndex === 5){
      return <ServiceListComponent/>;
    }else if(modelStore.selectedIndex ===4){
      return <Refinements />;
    }else if( modelStore.selectedIndex <= 4 ){
      return <InfoBox/>;
    }

    return null;
    
  }
  private renderProductInfo():React.ReactNode | null {
    if(modelStore.selectedIndex !== 0 && modelStore.selectedIndex !== 6){
      return <ProductInfoComponent/>
    }
    return null;
  }
  private renderContactForm():React.ReactNode | null {
    if(modelStore.selectedIndex === 6){
      return <ContactComponent/>
    }
    return null;
  }

}
export default App;



// WEBPACK FOOTER //
// ./src/App.tsx